import React from 'react';

import { FormField } from 'components';

const TimeSelector = () => (
  <>
    <FormField
      name="startTime"
      label="Start Time"
      tooltip="Specify when the offer begins."
      type="time"
    />
    <FormField
      name="endTime"
      label="End Time"
      tooltip="Specify when the offer ends."
      type="time"
    />
  </>
);

export default TimeSelector;
